'use strict';
const IntervalProgress = require('./interval-progress');
module.exports = function ScrollAnimator(intervalController) {
	const self = this;
	self.animate = function (domElement, targetState) {
		if (!Number.isFinite(targetState.top) ||
			!Number.isFinite(targetState.left) ||
			!Number.isFinite(targetState.duration)) {
			throw new Error('invalid-args');
		}
		if (targetState.left === domElement.scrollLeft && targetState.top === domElement.scrollTop) {
			return false;
		}
		const initialState = {
				left: domElement.scrollLeft,
				top: domElement.scrollTop
			},
			dX = targetState.left - initialState.left,
			dY = targetState.top - initialState.top,
			progress = (ratio) => {
				domElement.scrollLeft = dX * ratio + initialState.left;
				domElement.scrollTop = dY * ratio + initialState.top;
			};
		return new IntervalProgress(progress, targetState.duration, intervalController);
	};
};
